import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ShapeSizeConstraint } from '../shape-size-constraint'
import { Shape } from '../shape'
import { ShapePackagingStrategy } from '../shape-packaging-strategy'
import { BehaviorSubject } from 'rxjs'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import {
  ElderQuantityInputControlComponent,
  ElderValidationErrorDirective,
} from '@elderbyte/ngx-starter'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'

import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-shape-size-constraint-input',
  templateUrl: './shape-size-constraint-input.component.html',
  styleUrls: ['./shape-size-constraint-input.component.scss'],
  imports: [
    AsyncPipe,
    MatFormField,
    MatLabel,
    ElderQuantityInputControlComponent,
    MatError,
    ElderValidationErrorDirective,
    ElderTranslatePipe,
  ],
})
export class ShapeSizeConstraintInputComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  @Input()
  public namePrefix: string

  public readonly strategy$ = new BehaviorSubject<ShapePackagingStrategy>(null)
  public readonly shape$ = new BehaviorSubject<Shape>(null)
  public readonly sizeConstraint$ = new BehaviorSubject<ShapeSizeConstraint>(null)

  public readonly Strategy = ShapePackagingStrategy
  public readonly Shape = Shape

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  set strategy(value: ShapePackagingStrategy) {
    console.debug(`Updating strategy from ${this.strategy$.value} to ${value}`)
    this.strategy$.next(value)
  }

  @Input()
  set shape(value: Shape) {
    console.debug(`Updating shape from ${this.strategy$.value} to ${value}`)
    this.shape$.next(value)
  }

  @Input()
  set sizeConstraint(value: ShapeSizeConstraint) {
    console.debug(`Updating sizeConstraint from ${this.sizeConstraint$.value} to ${value}`)
    this.sizeConstraint$.next(value)
  }
}
